import React from 'react';
import { Card, Descriptions, Image, Tag, Space, Typography } from 'antd';

const { Title, Text } = Typography;

const ViewBanner = ({ viewdata, children }) => {
  if (!viewdata) {
    return (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        <Text type="secondary">No banner data to display</Text>
      </div>
    );
  }

  const getBannerPages = (record) => {
    const pages = [];
    if (record.home_page === 'Y') pages.push('Home');
    if (record.movie_page === 'Y') pages.push('Movie');
    if (record.series_page === 'Y') pages.push('Series');
    return pages;
  };

  const getShowName = (record) => {
    return record.show_type === 'movie' 
      ? record.video_show_title 
      : record.tv_show_name;
  };

  return (
    <div>
      <Title level={4}>Banner Details</Title>
      
      <Card style={{ marginBottom: '16px' }}>
        <Descriptions column={1} bordered>
          <Descriptions.Item label="Banner Name">
            <Text strong>{viewdata.banner_name}</Text>
          </Descriptions.Item>
          
          <Descriptions.Item label="Show Type">
            <Tag color="blue">{viewdata.show_type}</Tag>
          </Descriptions.Item>
          
          <Descriptions.Item label="Show Name">
            <Text>{getShowName(viewdata)}</Text>
          </Descriptions.Item>
          
          <Descriptions.Item label="Banner Pages">
            <Space>
              {getBannerPages(viewdata).map((page, index) => (
                <Tag key={index} color="green">{page}</Tag>
              ))}
            </Space>
          </Descriptions.Item>
          
          <Descriptions.Item label="Order">
            <Text>{viewdata.order || 1}</Text>
          </Descriptions.Item>
          
          <Descriptions.Item label="Status">
            <Tag color={viewdata.banner_is_active === 'Y' ? 'green' : 'red'}>
              {viewdata.banner_is_active === 'Y' ? 'Active' : 'Inactive'}
            </Tag>
          </Descriptions.Item>
          
          {viewdata.banner_image && (
            <Descriptions.Item label="Banner Image">
              <Image
                width={200}
                src={viewdata.banner_image}
                alt="Banner"
                style={{ borderRadius: '4px' }}
              />
            </Descriptions.Item>
          )}
        </Descriptions>
      </Card>
      
      {children}
    </div>
  );
};

export default ViewBanner;
